/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useHistory, useParams } from "react-router-dom";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { showSuccess } from "~/components/Toast";
import {
  AssignmentRule,
  AssignmentRuleRouteParams,
} from "~/models/assignmentRule";
import { ROUTES } from "~/routing";
import {
  generateActionConfirmText,
  generateActionSuccessText,
  useAxios,
} from "~/tools";

type AssignmentRuleDeleteProps = {
  assignmentRule: AssignmentRule;
};

function AssignmentRuleDelete({ assignmentRule }: AssignmentRuleDeleteProps) {
  const {
    customerId,
    assignmentRuleId,
  } = useParams<AssignmentRuleRouteParams>();

  const [isOpen, setIsOpen] = React.useState(false);

  const { showError } = useShowError();
  const { Axios } = useAxios();

  const history = useHistory();

  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        type="button"
        css={{ marginLeft: "auto" }}
        severity="medium"
        icon="trash"
      >
        Delete
      </Button>
      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={async () => {
          try {
            await Axios().delete(
              `/customers/${customerId}/assignmentRules/${assignmentRuleId}`
            );
            setIsOpen(true);
            showSuccess(
              generateActionSuccessText(`The ${assignmentRule?.name}`)()(
                "deleted"
              )()
            );
            history.push(
              `${ROUTES.customers.index}/${customerId}/assignment-rules/`
            );
          } catch (e) {
            showError(e.response);
          }
          setIsOpen(false);
        }}
        actionLabel="Delete"
        contentLabel="Delete Assignment Rule"
      >
        {generateActionConfirmText(`${assignmentRule?.name}`)("delete")()}{" "}
        <br />
      </ModalConfirm>
    </>
  );
}

export { AssignmentRuleDelete };
